export const FETCH_FILE_DATA_FAILURE = 'FETCH_FILE_DATA_FAILURE';
export const FETCH_FILE_DATA_SUCCESS = 'FETCH_FILE_DATA_SUCCESS';
export const FETCH_FILE_DATA_REQUEST = 'FETCH_FILE_DATA_REQUEST';
export const FETCH_DATA_PATH_DATA_REQUEST = 'FETCH_DATA_PATH_DATA_REQUEST';
export const FETCH_DATA_PATH_DATA_SUCCESS = 'FETCH_DATA_PATH_DATA_SUCCESS';
export const FETCH_DATA_PATH_DATA_FAILURE = 'FETCH_DATA_PATH_DATA_FAILURE';
export const SAVE_DATA_PATH_URL = 'SAVE_DATA_PATH_URL';
